import DownloadIcon from '@mui/icons-material/Download';
import { useWidget } from '../widget.hook';
import { useCallback } from 'react';
import { AppIconButton } from '@client/foundation/design-system/components';

export const OpenFileDownloadFormButton = () => {
  const { openWidget } = useWidget();

  const handleOpenFileDownloadForm = useCallback(() => {
    openWidget({ type: 'FileDownloadForm' });
  }, []);

  return (
    <AppIconButton
      title="Download"
      tone="primary"
      onClick={handleOpenFileDownloadForm}
    >
      <DownloadIcon />
    </AppIconButton>
  );
};
